import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { buildAvatarDataUrl, normalizeAvatarSrc } from '../utils/avatar';

const Avatar = ({
  name = '',
  username = '',
  src = null,
  alt = 'avatar',
  className = 'h-full w-full rounded-full object-cover',
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  const normalizedSrc = useMemo(() => normalizeAvatarSrc(src), [src]);
  const fallbackSrc = useMemo(
    () => buildAvatarDataUrl(name, username),
    [name, username]
  );

  useEffect(() => {
    setImageFailed(false);
  }, [normalizedSrc]);

  const resolvedSrc =
    !imageFailed && normalizedSrc ? normalizedSrc : fallbackSrc;

  return (
    <img
      className={className}
      src={resolvedSrc}
      alt={alt}
      onError={() => {
        if (resolvedSrc !== fallbackSrc) {
          setImageFailed(true);
        }
      }}
    />
  );
};

Avatar.propTypes = {
  name: PropTypes.string,
  username: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default Avatar;
